import * as React from 'react';
import { Box, HeadingText } from '@leagueplatform/genesis-core';

export const EventIndicator = ({
  eventText,
}: {
  eventText?: string;
}): React.ReactElement => (
  <Box
    css={{
      display: 'flex',
      alignItems: 'center',
      gap: '$half',
    }}
  >
    <Box
      css={{
        flex: 1,
        height: '1px',
        backgroundColor: '$onSurfaceBorderSubdued',
      }}
    />
    <HeadingText
      size="xs"
      level="display"
      css={{
        whiteSpace: 'nowrap',
      }}
    >
      {eventText}
    </HeadingText>
    <Box
      css={{
        flex: 1,
        height: '1px',
        backgroundColor: '$onSurfaceBorderSubdued',
      }}
    />
  </Box>
);
